"use client";
import React from "react";
function isBrowser() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
import * as BrowserSdk from "../browser/index.mjs";
import {
  Button as EdgeSdkButton,
  Columns as EdgeSdkColumns,
  Fragment as EdgeSdkFragment,
  Image as EdgeSdkImage,
  Section as EdgeSdkSection,
  Symbol as EdgeSdkSymbol,
  Text as EdgeSdkText,
  Video as EdgeSdkVideo,
  Blocks as EdgeSdkBlocks,
  Content as EdgeSdkContent,
  BuilderContext as EdgeSdkBuilderContext,
  setClientUserAttributes as EdgeSdksetClientUserAttributes
} from "./blocks-exports.mjs";
const Button = EdgeSdkButton;
const Columns = EdgeSdkColumns;
const Fragment = EdgeSdkFragment;
const Image = EdgeSdkImage;
const Section = EdgeSdkSection;
const Symbol = EdgeSdkSymbol;
const Text = EdgeSdkText;
const Video = EdgeSdkVideo;
const Blocks = (props) => isBrowser() ? /* @__PURE__ */ React.createElement(BrowserSdk.Blocks, { ...props }) : /* @__PURE__ */ React.createElement(EdgeSdkBlocks, { ...props });
const Content = (props) => isBrowser() ? /* @__PURE__ */ React.createElement(BrowserSdk.Content, { ...props }) : /* @__PURE__ */ React.createElement(EdgeSdkContent, { ...props });
const BuilderContext = EdgeSdkBuilderContext;
const setClientUserAttributes = EdgeSdksetClientUserAttributes;
export {
  Blocks,
  BuilderContext,
  Button,
  Columns,
  Content,
  Fragment,
  Image,
  Section,
  Symbol,
  Text,
  Video,
  setClientUserAttributes
};
